import React from 'react'
import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react/macro'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Visibility = () => {
  const { t } = useLingui()

  return (
    <>
      <Card gap='$4'>
        <Paragraph size='$5'>
          <Trans>
            Every Event on Guild is either{' '}
            <Paragraph size='$5' fontWeight='$7'>listed</Paragraph> or{' '}
            <Paragraph size='$5' fontWeight='$7'>unlisted</Paragraph>. This setting
            controls where the Event appears and who can discover it.
          </Trans>
        </Paragraph>
        <DocScreenshot
          src='docs/events/event-page.png'
          alt={t`Event page showing the Listed badge next to the event title indicating the Event is publicly discoverable`}
          caption={t`Listed Events display a badge on the Event page`}
        />
      </Card>

      <Card gap='$4'>
        <DocSection id='visibility-types' title={t`Visibility Types`}>
          <YStack gap='$3'>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon name='globe' size='$5' color='$color' flexShrink={0} marginTop={2} />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>Listed Events</Paragraph> — Fully
                  public. They appear on your Guild's Events tab, in search results, and in
                  the global Events listing. Anyone browsing Guild can discover a listed
                  Event and RSVP or purchase tickets.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon name='lock-closed' size='$5' color='$color' flexShrink={0} marginTop={2} />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>Unlisted Events</Paragraph> — Do not
                  appear in any public listings or search results. They are only accessible
                  via a direct link. This is useful for private gatherings, invite-only
                  Events, or Events that are still being set up and not ready to be
                  announced publicly.
                </Trans>
              </Paragraph>
            </XStack>
          </YStack>
        </DocSection>
      </Card>

      <Card gap='$4'>
        <DocSection id='changing-visibility' title={t`Changing Visibility`}>
          <Paragraph size='$5'>
            <Trans>
              You can toggle visibility at any time from{' '}
              <Link href='/docs/events/settings'>Event Settings</Link> under the
              General section. Changing an Event from unlisted to listed makes it
              immediately discoverable. Changing it back to unlisted removes it from
              public listings but does not affect existing attendees — anyone who has
              already RSVPed retains their spot.
            </Trans>
          </Paragraph>
          <Paragraph size='$5'>
            <Trans>
              The Event page displays a{' '}
              <Paragraph size='$5' fontWeight='$7'>Listed</Paragraph> badge next to the
              title so organizers can quickly confirm the current visibility setting. An
              unlisted Event shows no badge, reminding organizers that it is only
              reachable by sharing the link directly.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>
    </>
  )
}

export default Visibility
